import {InjectionToken} from "@angular/core";
import {EventTracker} from "./EventTracker";

export const EVENT_TRACKER = new InjectionToken<EventTracker>("EVENT_TRACKER");
export const HUBSPOT_TRACKING_SCRIPT_SRC = new InjectionToken<string>("HUBSPOT_TRACKING_SCRIPT_SRC");
export const MIX_PANEL_API_KEY = new InjectionToken<string>("Mix Panel API Key");
